// extracted by mini-css-extract-plugin
module.exports = {"list":"list-card-description_list__Akntj","item":"list-card-description_item__uhDaD"};